import { render, staticRenderFns } from "./QrcodeNpoCard.vue?vue&type=template&id=f2b585c2&scoped=true&"
import script from "./QrcodeNpoCard.vue?vue&type=script&lang=js&"
export * from "./QrcodeNpoCard.vue?vue&type=script&lang=js&"
import style0 from "./QrcodeNpoCard.vue?vue&type=style&index=0&id=f2b585c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2b585c2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VCardText,VImg,VListItem,VListItemContent,VListItemSubtitle,VListItemTitle,VSheet})
